import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'
import { matchContainerPadding } from '@components/Container/index.style'

export const MainContainer = styled.div`
    ${mq.tabletP} {
        ${matchContainerPadding('padding-left')}
        ${matchContainerPadding('padding-right')}
    }
    background-color: ${colors.white};
    .listMain > div:last-child {
        .caseStudyContainer {
            border-bottom:none;
        }
    }
`

export const FilterMain = styled.div`
  background-color: ${colors.white};
  color: ${colors.charcoal};
  padding: 30px 0;
  border-bottom: 1px solid ${colors.mist};
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  ${mq.tabletLMax} {
        border-bottom: none;
        padding: 20px 15px;
        gap: 15px;
    }
`
export const Title = styled.div`
    width: 100%;
    margin-bottom: 20px;
    font-size: 18px;
    ${mq.tabletL} {
        display: none;
    }
`

export const MainList = styled.div`
    background-color: ${colors.white};
    color: ${colors.charcoal};
    position: relative;
    > .pin-spacer {
        height: 0 !important;
    }
    .gridMain {
        ${mq.tabletPMax} {
            padding: 0 15px;
        }
    }
`

export const CMSButtonContainer = styled.div`
    width: 15%;
`